import { c as _c } from "react/compiler-runtime";
import cn from 'classnames';
import css from './actions.module.scss';
import Copy from './copy.icon.svg';
interface Props {
  value: string;
  onRefresh(): void;
}
export function Actions(t0) {
  const $ = _c(12);
  const {
    value,
    onRefresh
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn(css.button, css.primary);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== value) {
    t2 = () => navigator.clipboard.writeText(value);
    $[1] = value;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className={css.icon}><Copy /></span>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2) {
    t4 = <button className={t1} onClick={t2}>{t3}Copy key</button>;
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span className={css.icon}>↻</span>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== onRefresh) {
    t6 = <button className={css.button} onClick={onRefresh}>{t5} Refresh</button>;
    $[7] = onRefresh;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t4 || $[10] !== t6) {
    t7 = <div className={css.actions}>{t4}{t6}</div>;
    $[9] = t4;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
}